import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import * as urls from '../../helpers/url_helper';

import CompatibilityForm from './DeviceForm';

function CompatibilityFormModal(props) {
  const { shown, t, entity } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [entity, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="md"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
        >
          {t('Save Device')}
        </h5>
        <button
          onClick={() => setModalOpen(false)}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <CompatibilityForm
          actionUrl={urls.POST_DEVICES}
          entity={entity}
          onSuccess={onSuccess}
        />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => setModalOpen(false)}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="ItemEditForm"
          className="btn btn-primary"
        >
          {t('Save Changes')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

CompatibilityFormModal.defaultProps = {
  shown: false,
  entity: {},
  onSuccess: () => { },
};

CompatibilityFormModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(CompatibilityFormModal));
